"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportAddApi = reportAddApi;
exports.reportApproveApi = reportApproveApi;
exports.reportBuildListApi = reportBuildListApi;
exports.reportChangeApi = reportChangeApi;
exports.reportDeleteApi = reportDeleteApi;
exports.reportDownloadUrlApi = reportDownloadUrlApi;
exports.reportEditApi = reportEditApi;
exports.reportEditSaveApi = reportEditSaveApi;
exports.reportFilterApi = reportFilterApi;
exports.reportListApi = reportListApi;
exports.reportLockedApi = reportLockedApi;
exports.reportPauseApi = reportPauseApi;
exports.reportPlayApi = reportPlayApi;
exports.reportReadApi = reportReadApi;
exports.reportRestrictApi = reportRestrictApi;
exports.reportSoftDeleteApi = reportSoftDeleteApi;
exports.reportSoftDeleteListApi = reportSoftDeleteListApi;
exports.reportSoftDeleteRestoreApi = reportSoftDeleteRestoreApi;
exports.reportSubmitApi = reportSubmitApi;
exports.reportUnlockedApi = reportUnlockedApi;
exports.reportUnrestrictApi = reportUnrestrictApi;
exports.reportUpdateApi = reportUpdateApi;
exports.reportViewConfigApi = reportViewConfigApi;
exports.reportViewEditorListApi = reportViewEditorListApi;
exports.reportViewSnapshotsApi = reportViewSnapshotsApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * controller report add
 * @param payload
 * @returns api response
 * @description this function used to controller report add..
 */
function reportAddApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ReportService.report.addReport), params);
}

/**
 * controller report update
 * @param payload
 * @returns api response
 * @description this function used to controller report add..
 */
function reportUpdateApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ReportService.report.updateReport), params);
}
/**
 * controller report edit
 * @param payload
 * @returns api response
 * @description this function used to controller report edit.
 */
function reportEditSaveApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.report.edit), params);
}
/**
 * controller report edit
 * @param payload
 * @returns api response
 * @description this function used to controller report edit.
 */
function reportEditApi(params) {
  var headersConfig = JSON.parse(sessionStorage.getItem("headersConfigReport")) || {
    headers: {
      referrer: window.location.origin + "/platform/report-edit",
      originReferer: window.location.origin + "/platform"
    }
  };
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportService.report.edit), params, headersConfig);
}

/**
 * controller report read
 * @param payload
 * @returns api response
 * @description this function used to controller report read.
 */
function reportReadApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportService.report.read), params);
}

/**
 * controller report change
 * @param payload
 * @returns api response
 * @description this function used to controller report change.
 */
function reportChangeApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.report.change), params);
}

/**
 * controller list reports
 * @param payload
 * @returns api response
 * @description this function used to bulk bulk controller list reports.
 */
function reportListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportService.report.list), params);
}

/**
 * controller report submit
 * @param payload
 * @returns api response
 * @description this function used to controller report submit.
 */
function reportSubmitApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.report.submit), params);
}

/**
 * controller report approve
 * @param payload
 * @returns api response
 * @description this function used to controller report approve.
 */
function reportApproveApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.report.approve), params);
}

/**
 * controller report delete
 * @param payload
 * @returns api response
 * @description this function used to controller report delete.
 */
function reportDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.ReportService.report.delete), params);
}

// apis not available for below

/**
 * controller report update
 * @param payload
 * @returns api response
 * @description this function used to controller report update.
 */
function reportFilterApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportService.report.filter), params);
}

/**
 * controller report build list
 * @param payload
 * @returns api response
 * @description this function used to controller report build list.
 */
function reportBuildListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportService.report.buildList), params);
}

/**
 * controller list reports
 * @param payload
 * @returns api response
 * @description this function used to bulk bulk controller list reports.
 */
function reportPauseApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.report.pause), params);
}

/**
 * controller report submit
 * @param payload
 * @returns api response
 * @description this function used to controller report submit.
 */
function reportPlayApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.report.play), params);
}

/**
 * controller report delete
 * @param payload
 * @returns api response
 * @description this function used to controller report delete.
 */
function reportDownloadUrlApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportService.report.downloadEmail), params);
}

/**
 * controller report save
 * @param payload
 * @returns api response
 * @description this function used to controller report save.
 */
function reportRestrictApi(params) {
  var _sessionStorage;
  var headersConfig = JSON === null || JSON === void 0 ? void 0 : JSON.parse((_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.getItem("headersConfigRestrict"));
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.report.restrict), params, headersConfig);
}

/**
 * controller report build list
 * @param payload
 * @returns api response
 * @description this function used to controller report build list.
 */
function reportUnrestrictApi(params) {
  var _sessionStorage2;
  var headersConfig = JSON === null || JSON === void 0 ? void 0 : JSON.parse((_sessionStorage2 = sessionStorage) === null || _sessionStorage2 === void 0 ? void 0 : _sessionStorage2.getItem("headersConfigUnrestrict"));
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.report.unrestrict), params, headersConfig);
}

/**
 * controller report save
 * @param payload
 * @returns api response
 * @description this function used to controller report save.
 */
function reportLockedApi(params) {
  var _sessionStorage3;
  var headersConfig = JSON === null || JSON === void 0 ? void 0 : JSON.parse((_sessionStorage3 = sessionStorage) === null || _sessionStorage3 === void 0 ? void 0 : _sessionStorage3.getItem("headersConfigLock"));
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.report.locked), params, headersConfig);
}

/**
 * controller report build list
 * @param payload
 * @returns api response
 * @description this function used to controller report build list.
 */
function reportUnlockedApi(params) {
  var _sessionStorage4;
  var headersConfig = JSON === null || JSON === void 0 ? void 0 : JSON.parse((_sessionStorage4 = sessionStorage) === null || _sessionStorage4 === void 0 ? void 0 : _sessionStorage4.getItem("headersConfigUnlock"));
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.report.unlocked), params, headersConfig);
}

/**
 * controller report delete
 * @param payload
 * @returns api response
 * @description this function used to controller report delete.
 */
function reportViewSnapshotsApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportService.report.viewSnapshots), params);
}

/**
 * controller report save
 * @param payload
 * @returns api response
 * @description this function used to controller report save.
 */
function reportViewEditorListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportService.report.viewEditorList), params);
}

/**
 * controller report build list
 * @param payload
 * @returns api response
 * @description this function used to controller report build list.
 */
function reportViewConfigApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportService.report.viewConfig), params);
}

/**
 * controller report soft delete
 * @param payload
 * @returns api response
 * @description this function used to controller report soft delete.
 */
function reportSoftDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.ReportService.report.softDelete), params);
}

/**
 * controller report soft delete list
 * @param payload
 * @returns api response
 * @description this function used to controller report soft delete list.
 */
function reportSoftDeleteListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportService.report.softDeleteList), params);
}

/**
 * controller report soft delete restore
 * @param payload
 * @returns api response
 * @description this function used to controller report soft delete restore.
 */
function reportSoftDeleteRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.report.softDeleteRestore), params);
}